<template>
  <div class="wrapper">
    <div class="animated fadeIn">
      <b-row>
        <b-col cols="12">
          <b-card
            header-tag="header"
            footer-tag="footer">
            <div slot="header">
              <i class="fa fa-search-plus"></i><strong> Trazabilidad</strong>
              <div class="card-header-actions">
                  <small class="text-muted">-</small>
              </div>
            </div>
            <div class="text-left" @click="goBack"> <b-link>Atras</b-link></div>
            <div class="text-right" > <b-link to="/trazabilidad/search">Buscar nuevo pallet</b-link></div>
                   <br/>
              <h1>Detalle proceso (<span v-if="numProcess">{{numProcess}})</span></h1>
                 <br/>

        <div v-if="process">
                 
          <h6 class="mb-2 font-weight-bold">Entrada a Proceso:</h6>
        <div class="table-responsive-sm">
          <table class="table  table-sm">
            <thead>
              <tr class="font-weight-bold text-uppercase">
                <th class="text-center">#</th>
                <th>Pallet</th>
                <th>Guía - Lote</th>
                <th>Producto - Tipo</th>
                <th>Variedad - Condición</th>
                <th>Env./Emb.</th>
                <th>Spec</th>
                <th class="text-center">Cantidad</th>
                <th class="text-right">Kg Netos</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(content, index) in process.contents_in">
                <td class="text-center align-middle">{{index+1}}</td>
                <td class="left align-middle">
                     <a
                              target="_blank"
                              href="#"
                              title="Ver en detalle"
                              @click.prevent="seeDetailContent(content.pallet,content.pallet_number)">
                             {{content.pallet_number}}
                              </a>
                     </td>
                <td class="left align-middle">
                     <a
                        target="_blank"
                        href="#"
                        title="Ver en detalle"
                        @click.prevent="seeGuideDetail(content.waybill,content.waybill_number)"
                        
                    >{{content.waybill_number}}</a>
                     - 
                     <a
                        target="_blank"
                        href="#"
                        title="Ver en detalle"
                        @click.prevent="seeLotDetail(content.waybill,content.lot_number)"
                        
                    >{{content.lot_number}}</a>
                     
                     
                      </td>
                <td class="align-middle left">{{content.product_name}} - {{content.product_type_name}}</td>
                <td class="align-middle left">{{content.variety_name}} - {{content.condition}}</td>
                <td class="align-middle left">{{content.container.name}}</td>
                <td class="align-middle left">{{content.string_specs}}</td>
                <td class="align-middle text-center">{{content.quantity}}</td>
                <td class="align-middle text-right">{{content.net_kilograms}} Kg</td>
<!--                <td class="align-middle text-right">{{dhPercentage(content.net_kilograms) }} %</td>-->
              </tr>
            </tbody>
            <tfoot>
              <tr class="font-weight-bold">
                <td class="text-center"></td>
                <td class="left"></td>
                <td class="left"></td>
                <td class="left"></td>
                <td class="left"></td>
                <td class="left"></td>
                <td class="text-right">TOTALES</td>
                <td class="text-center">{{totalQuantityIn}}</td>
                <td class="text-right">{{process.total_kilograms}} Kg</td>
<!--                <td class="text-right">100.00 %</td>-->
              </tr>
            </tfoot>
          </table>
        </div>

        <h6 class="mb-2 font-weight-bold">Salida de Proceso:</h6>
        <div class="table-responsive-sm">
          <table class="table  table-sm">
            <thead>
              <tr class="font-weight-bold text-uppercase">
                <th class="text-center">#</th>
                <th>Pallet</th>
                <th>Producto - Tipo</th>
                <th>Variedad - Condición</th>
                <th>Env./Emb.</th>
                <th>Spec</th>
                <th class="text-center">Cantidad</th>
                <th class="text-right">Kg Exportación</th>
                <th class="text-right">DH/SOBREPESO</th>
                <th class="text-right">Kg NETOS</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(content, index) in process.contents_out">
                <td class="text-center align-middle">{{index+1}}</td>
                <td class="left align-middle">
                     <a
                              target="_blank"
                              href="#"
                              title="Ver en detalle"
                              @click.prevent="seeDetailContent(content.pallet,content.pallet_number)">
                             {{content.pallet_number}}
                              </a>
                    </td>
                <td class="left">{{content.product_name}} - {{content.product_type_name}}</td>
                <td class="left">{{content.variety_name}} - {{content.condition}}</td>
                <td class="left">{{content.container.name}}</td>
                <td class="left">{{content.string_specs}}</td>
                <td class="text-center">{{content.quantity}}</td>
                <td class="text-right">{{content.exportable_kilograms}} Kg</td>
                <td class="text-right">{{dh(content.exportable_kilograms,content.net_kilograms)}} Kg</td>
                <td class="text-right">{{content.net_kilograms}} Kg</td>
              </tr>
            </tbody>
            <tfoot>
              <tr class="font-weight-bold">
                <td class="text-center"></td>
                <td class="left"></td>
                <td class="left"></td>
                <td class="left"></td>
                <td class="left"></td>
                <td class="text-right">TOTALES</td>
                <td class="text-center">{{totalQuantityOut}}</td>
                <td class="text-right">{{totalExportedKilograms}} Kg</td>
                <td class="text-right">{{totalDHKilograms}} Kg</td>
                <td class="text-right">{{process.total_kilograms}} Kg</td>
              </tr>
            </tfoot>
          </table>
        </div>
                   
</div>

          </b-card>
        </b-col>
      </b-row>
    </div>
  </div>

</template>



<script>


  import Vue from 'vue'
  import {ClientTable, Event} from 'vue-tables-2'
  import moment from 'moment';
 

  Vue.use(ClientTable);


export default {
  name: 'detailedProcess',
  props: ['process_id','numProcess'],
  created () {
  },
  data () {
    return {
      process: null,
    }
  },
   filters: {
        moment: function (date) {
          return moment(date).format('DD-MM-YYYY');
        }
      },
      computed: {
        totalQuantityIn () {
          return this.process.contents_in.reduce((total, item) => total + item.quantity, 0);
        },
        totalQuantityOut () {
          return this.process.contents_out.reduce((total, item) => total + item.quantity, 0);
        },
        totalExportedKilograms () {
          var value = this.process.contents_out.reduce((acc, item) => acc + item.exportable_kilograms, 0) ;
          return value.toFixed(2)
        },
        totalPercentage () {
          var value = this.process.contents_out.reduce((acc, item) => acc + parseFloat(item.net_kilograms), 0);
          value = (value / this.process.total_kilograms)*100;
          return value.toFixed(2);
        },
        totalDHKilograms () {
          const value = this.process.contents_out.reduce((acc, item) => acc + parseFloat(this.dh(item.exportable_kilograms, item.net_kilograms)),0);
          return value.toFixed(2) ;
        },
        groupedData () {
          return _(this.process.contents_out)
                  .groupBy('product_type_name')
                  .map((product_type, id) => ({
                    producto: id,
                    kg_export: _.sumBy(product_type, 'exportable_kilograms').toFixed(2),
                    kg_sobrepeso: _.sumBy(product_type, x => parseFloat(x.net_kilograms - x.exportable_kilograms)).toFixed(2),
                    bultos: _.sumBy(product_type, 'quantity'),
                    porcentaje: (
                      _.sumBy(product_type, x => parseFloat(x.net_kilograms))/this.process.total_kilograms
                    * 100 ).toFixed(2)  +"%",

                  }))
                  .value()
        },
      },
    methods: {
          getProcess (process_id) {
          this.$axios.get ('/api/v1/process/'+process_id+'/detailed_with_traceability/')
          .then(res => {
            this.process = res.data;
          })
          .catch(error => console.log(error))
        },
        seeGuideDetail(waybill_id,numGuia)
        {
    
            this.$router.push("/trazabilidad/detailed-waybill-reception/"+waybill_id+"/"+numGuia);
        },
        seeDetailContent(id_pallet,numero_pallet){
               this.$router.push("/trazabilidad/detailed-pallet-trazability/"+id_pallet+"/"+numero_pallet);
        },
        goBack(){
             this.$router.go(-1)
         },
         moment: function () {
          return moment();
        },
        dh (exportable_kilogram, net_kilogram) {
          const value = (net_kilogram - exportable_kilogram);
          return exportable_kilogram == 0 ? 0 : parseFloat(value).toFixed(2)
        },
         seeLotDetail(waybill_id,numLote)
        {
            this.$router.push("/trazabilidad/detailed-lote/"+waybill_id+"/"+numLote);
        },
        },
      mounted(){
            this.getProcess(this.process_id);
    }
}

</script>
